import { render } from "./RecaptchaContainer.vue?vue&type=template&id=08386ab4"
import script from "./RecaptchaContainer.vue?vue&type=script&lang=js"
export * from "./RecaptchaContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__